import React, { FC, ReactNode } from 'react'
import styles from './PopupMenu.module.scss'
import { useToggleLayer, Arrow } from 'react-laag'
import cx from 'classnames'

type PopupMenuProps = {
  children: ReactNode[]
  trigger: ReactNode
  triggerOffset?: number
  className?: string
  label?: string
}

export const PopupMenu: FC<PopupMenuProps> = ({
  children,
  trigger,
  triggerOffset = 0,
  ...props
}) => {
  const [element, toggleLayerProps] = useToggleLayer(
    ({ isOpen, layerProps, arrowStyle, layerSide }) =>
      isOpen && (
        <ul
          role="menu"
          id="menu-list"
          className={cx(styles.menuList, props.className)}
          {...layerProps}
        >
          {children.map((item, index) => {
            return (
              <li
                key={index}
                role="menuitem"
                aria-controls="menu-list"
                tabIndex={-1}
                onClick={() => toggleLayerProps.close()}
              >
                {item}
              </li>
            )
          })}
          <Arrow
            style={arrowStyle}
            layerSide={layerSide}
            backgroundColor={styles.whiteColor}
            borderWidth={1}
            borderColor={styles.borderGrey}
          />
        </ul>
      ),
    {
      placement: {
        anchor: 'BOTTOM_CENTER',
        autoAdjust: true,
        triggerOffset: triggerOffset,
        possibleAnchors: ['BOTTOM_CENTER'],
      },
      closeOnOutsideClick: true,
    },
  )

  return (
    <div className={styles.popupMenu}>
      <button
        aria-haspopup="true"
        aria-controls="menu-list"
        aria-expanded={toggleLayerProps.isOpen}
        className={styles.menuButton}
        aria-label={props.label}
        onClick={
          toggleLayerProps.isOpen ? toggleLayerProps.close : toggleLayerProps.openFromMouseEvent
        }
      >
        {trigger}
      </button>
      {element}
    </div>
  )
}

PopupMenu.displayName = 'PopupMenu'
